import { render } from "./LeitnerBoxItems.vue?vue&type=template&id=1ee83ef2&scoped=true&ts=true"
import script from "./LeitnerBoxItems.vue?vue&type=script&lang=ts"
export * from "./LeitnerBoxItems.vue?vue&type=script&lang=ts"

import "./LeitnerBoxItems.vue?vue&type=style&index=0&id=1ee83ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee83ef2"]])

export default __exports__